// extracted by mini-css-extract-plugin
var _1 = "Tabs-moduleprofileTabsLoading__r2lBO Container-modulecontent__hwVr6";
export { _1 as "profileTabsLoading" }
